<template>
  <b-card style="padding:40px;">
    <h5><b>VIEW USER</b></h5>
    <hr />

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Name </label>
          <b-form-input
            v-model="form.name"
            :id="`input-name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Date Of Birth</label>
          <b-form-input
            v-model="form.dob"
            :id="`input-dob`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Company Name</label>
          <b-form-input
            v-model="form.comp_name"
            :id="`input-comp_name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Role</label>
          <b-form-input
            v-model="form.role"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group v-if="form.role == 'Home Dealer' || form.role == 'Agent'">
          <label v-if="form.role == 'Home Dealer'" :for="`input-role`"
            >Stokist Name</label
          >
          <label v-if="form.role == 'Agent'" :for="`input-role`"
            >Home Dealer Name</label
          >
          <b-form-input
            v-model="form.stokist_name"
            :id="`input-stokist_name`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`">Address</label>
          <b-form-input
            v-model="form.add1"
            :id="`input-add1`"
            :type="`text`"
            readonly
          ></b-form-input
          ><br />
          <b-form-input
            v-model="form.add2"
            :id="`input-add2`"
            :type="`text`"
            readonly
          ></b-form-input
          ><br />
          <b-form-input
            v-model="form.add3"
            :id="`input-add3`"
            :type="`text`"
            readonly
          ></b-form-input
          ><br />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">State</label>
          <b-form-input
            v-model="form.state"
            :id="`input-state`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">City</label>
          <b-form-input
            v-model="form.city"
            :id="`input-city`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Postcode</label>
          <b-form-input
            v-model="form.postcode"
            :id="`input-postcode`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">email</label>
          <b-form-input
            v-model="form.email"
            :id="`input-email`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Phone Number</label>
          <b-form-input
            v-model="form.phone_no"
            :id="`input-email`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-accno`">Account No.</label>
          <b-form-input
            v-model="form.accno"
            :id="`input-accno`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-credit`">Credit Terms</label>
          <b-form-input
            v-model="form.credit_terms"
            :id="`input-credit`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row align="right">
      <b-col>
        <b-button variant="danger" size="sm" @click="onClickBack">
          BACK
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      chiller: [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
      ],
      role: [],
      form: {
        name: "",
        dob: "",
        comp_name: "",
        role: "",
        stokist_name: "",
        chiller: "",
        add1: "",
        add2: "",
        add3: "",
        state: "",
        city: "",
        postcode: "",
        email: "",
        phone_no: "",
        credit_terms: "",
        accno: ""
      }
    };
  },
  created() {
    this.showUser();
    // this.getUpline();
  },
  methods: {
    onClickBack() {
      let path = `/user_management?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}&state=${this.$route.query.state}&access_lvl=${this.$route.query.access_lvl}&email=${this.$route.query.email}`;

      this.$router.push({
        path: path
      });
    },
    showUser() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.name;
            this.form.dob = res.data.data.dob;
            this.form.comp_name = res.data.data.company;
            this.form.role = res.data.data.role_details.desc;
            this.form.chiller = res.data.data.chiller;
            this.form.add1 = res.data.data.add1;
            this.form.add2 = res.data.data.add2;
            this.form.add3 = res.data.data.add3;
            this.form.state = res.data.data.state_details.desc;
            this.form.city = res.data.data.city;
            this.form.postcode = res.data.data.postcode;
            this.form.email = res.data.data.email;
            this.form.phone_no = res.data.data.phone_no;
            this.form.stokist_name = res.data.data.downline
              ? res.data.data.downline.userdetails.name
              : "";
            this.form.credit_terms = res.data.data.credit_terms;
            this.form.accno = res.data.data.accno;
          }
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
